import { makeStyles } from "@material-ui/core";
import styled from "styled-components";
import { theme as themeConfig } from '@themes';

export const GeneralStyle = styled.div`
  display: flex;
  .ContentToolbar {
    width: 18% !important;
    float: left !important;
    @media only screen and (max-width: 1024px) {
      left: ${({ user }) => (user ? "7%" : "0")};
    }
  }
  .ContentHeader {
    width: 100% !important;
    display: flex;
    z-index: 6;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    box-shadow: none;
    height: 4.612vw;
    min-height: 40px;
    max-height: 65px;
    @media only screen and (max-width: 1024px) {
      position: relative;
    }
    z-index: 80;
  }
  .bottomMenu {
    position: absolute !important;
    bottom: 0;
    width: 100%;
  }
  .menu-separator {
    border-bottom: none;
  }
  .menu-padding-top {
    padding-top: 15px;
  }
  .choiceSelected-${(props) => props.choice.menu} {
    ${({ isCollapse }) => {
    return `
        svg{
          path{
            fill: ${isCollapse ? themeConfig.neutral.white + ";" : themeConfig.sidebar.selected + ";"}
          }
        }
        span.widget-icon{
          color: ${isCollapse ? themeConfig.neutral.white + ";" : themeConfig.sidebar.selected + ";"}
        }
        ${isCollapse ? "background: " + themeConfig.sidebar.selected + ";" : ""}
        ${isCollapse ? "" : "color: " + themeConfig.sidebar.selected + " !important;"}
        ${isCollapse ? "border-radius: 5px;" : ""}
      `;
  }}
  }
  .subchoiceSelected-${(props) => props.choice.submenu} {
    background: ${({ theme }) => theme.background.tertiary};
  }
  .pro-sidebar .pro-menu > ul > .pro-sub-menu > .pro-inner-list-item {
    background-color: ${({ theme }) => theme.neutral.white};
    div {
      ul {
        padding-top: 5px;
        padding-bottom: 5px;
      }
    }
  }
  .pro-sidebar > .pro-sidebar-inner {
    background-color: ${({ theme }) => theme.neutral.white};
  }
  .pro-inner-item {
    padding: 4px 12px 4px 17px !important;
  }
  .pro-sidebar {
    color: ${({ theme }) => theme.text.primary};
  }
  
  /* ============================================
     LOGICA DE SIDEBAR - Staff Engineer Approach
     
     Collapsed:  Normal = Negro | Hover = Blanco | Selected = Blanco
     Expanded:   Normal = Negro | Hover = Negro+Gris | Selected = Blanco
     ============================================ */

  /* ---- ESTADO: NORMAL (sin hover, sin selección) ---- */
  .pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item {
    color: ${({ theme }) => theme.text.primary};
  }
  .pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item svg path {
    fill: ${({ theme }) => theme.text.primary} !important;
  }
  .pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item span {
    color: ${({ theme }) => theme.text.primary};
  }

  /* ---- ESTADO: HOVER (mouse encima, NO seleccionado) ---- */
  /* Sidebar EXPANDIDO - hover con fondo gris suave */
  .pro-sidebar:not(.collapsed) .pro-menu .pro-menu-item:not(.pro-menu-item--active):not(.pro-menu-item--selected):not(.active):not(.selected) > .pro-inner-item:hover {
    background: ${({ theme }) => theme.neutral.gray[200]} !important;
    color: ${({ theme }) => theme.text.primary} !important;
    border-radius: 5px;
  }
  .pro-sidebar:not(.collapsed) .pro-menu .pro-menu-item:not(.pro-menu-item--active):not(.pro-menu-item--selected):not(.active):not(.selected) > .pro-inner-item:hover svg path {
    fill: ${({ theme }) => theme.text.primary} !important;
  }
  
  /* Sidebar COLAPSADO - hover con fondo negro e icono blanco */
  .pro-sidebar.collapsed .pro-menu .pro-menu-item:not(.pro-menu-item--active):not(.pro-menu-item--selected):not(.active):not(.selected) > .pro-inner-item:hover {
    background: ${themeConfig.button.primary} !important;
    color: ${themeConfig.neutral.white} !important;
    border-radius: 5px;
  }
  .pro-sidebar.collapsed .pro-menu .pro-menu-item:not(.pro-menu-item--active):not(.pro-menu-item--selected):not(.active):not(.selected) > .pro-inner-item:hover svg path {
    fill: ${themeConfig.neutral.white} !important;
  }
  .pro-sidebar.collapsed .pro-menu .pro-menu-item:not(.pro-menu-item--active):not(.pro-menu-item--selected):not(.active):not(.selected) > .pro-inner-item:hover span {
    color: ${themeConfig.neutral.white} !important;
  }
  .pro-sidebar.collapsed .pro-menu .pro-menu-item:not(.pro-menu-item--active):not(.pro-menu-item--selected):not(.active):not(.selected) > .pro-inner-item:hover .widget-icon {
    color: ${themeConfig.neutral.white} !important;
  }

  /* Hover para SubMenus - mismo comportamiento */
  .pro-sidebar:not(.collapsed) .pro-menu .pro-sub-menu:not(.pro-menu-item--active):not(.pro-menu-item--selected):hover {
    background: ${({ theme }) => theme.neutral.gray[200]} !important;
    color: ${({ theme }) => theme.text.primary} !important;
    border-radius: 5px;
  }
  .pro-sidebar.collapsed .pro-menu .pro-sub-menu:not(.pro-menu-item--active):not(.pro-menu-item--selected):hover {
    background: ${themeConfig.button.primary} !important;
    color: ${themeConfig.neutral.white} !important;
    border-radius: 5px;
  }
  .pro-sidebar.collapsed .pro-menu .pro-sub-menu:not(.pro-menu-item--active):not(.pro-menu-item--selected):hover svg path {
    fill: ${themeConfig.neutral.white} !important;
  }
  .pro-sidebar.collapsed .pro-menu .pro-sub-menu:not(.pro-menu-item--active):not(.pro-menu-item--selected):hover .widget-icon {
    color: ${themeConfig.neutral.white} !important;
  }

  /* ---- ESTADO: SELECTED/ACTIVE (seleccionado) ---- */
  /* IMPORTANTE: Los items seleccionados mantienen su estilo incluso con hover */
  .pro-sidebar .pro-menu .pro-menu-item--active > .pro-inner-item,
  .pro-sidebar .pro-menu .pro-menu-item.active > .pro-inner-item,
  .pro-sidebar .pro-menu .pro-menu-item--selected > .pro-inner-item,
  .pro-sidebar .pro-menu .pro-menu-item.selected > .pro-inner-item,
  .pro-sidebar .pro-sub-menu.pro-menu-item--active > .pro-inner-item,
  .pro-sidebar .pro-sub-menu.pro-menu-item--selected > .pro-inner-item {
    background: ${themeConfig.sidebar.selected} !important;
    color: ${themeConfig.sidebar.selectedText} !important;
    border-radius: 5px;
  }
  .pro-sidebar .pro-menu .pro-menu-item--active > .pro-inner-item svg path,
  .pro-sidebar .pro-menu .pro-menu-item.active > .pro-inner-item svg path,
  .pro-sidebar .pro-menu .pro-menu-item--selected > .pro-inner-item svg path,
  .pro-sidebar .pro-menu .pro-menu-item.selected > .pro-inner-item svg path,
  .pro-sidebar .pro-sub-menu.pro-menu-item--active > .pro-inner-item svg path,
  .pro-sidebar .pro-sub-menu.pro-menu-item--selected > .pro-inner-item svg path {
    fill: ${themeConfig.sidebar.selectedText} !important;
  }
  .pro-sidebar .pro-menu .pro-menu-item--active > .pro-inner-item span,
  .pro-sidebar .pro-menu .pro-menu-item.active > .pro-inner-item span,
  .pro-sidebar .pro-menu .pro-menu-item--selected > .pro-inner-item span,
  .pro-sidebar .pro-menu .pro-menu-item.selected > .pro-inner-item span {
    color: ${themeConfig.sidebar.selectedText} !important;
  }

  /* Hover en items seleccionados - mantiene el estilo de seleccionado (no cambia a hover) */
  .pro-sidebar .pro-menu .pro-menu-item--active > .pro-inner-item:hover,
  .pro-sidebar .pro-menu .pro-menu-item.active > .pro-inner-item:hover,
  .pro-sidebar .pro-menu .pro-menu-item--selected > .pro-inner-item:hover,
  .pro-sidebar .pro-menu .pro-menu-item.selected > .pro-inner-item:hover,
  .pro-sidebar .pro-sub-menu.pro-menu-item--active:hover,
  .pro-sidebar .pro-sub-menu.pro-menu-item--selected:hover {
    background: ${themeConfig.sidebar.selected} !important;
    color: ${themeConfig.sidebar.selectedText} !important;
  }
  .pro-sidebar .pro-menu .pro-menu-item--active > .pro-inner-item:hover svg path,
  .pro-sidebar .pro-sub-menu.pro-menu-item--active:hover svg path {
    fill: ${themeConfig.sidebar.selectedText} !important;
  }

  /* ---- FLECHAS DE SUBMENU ---- */
  /* Normal - flechas negras */
  .pro-sidebar .pro-menu-item > .pro-inner-item > span[class*="pro-arrow"] {
    border-color: ${({ theme }) => theme.text.primary} !important;
  }
  /* Selected - flechas blancas */
  .pro-sidebar .pro-menu-item--active > .pro-inner-item > span[class*="pro-arrow"],
  .pro-sidebar .pro-menu-item.selected > .pro-inner-item > span[class*="pro-arrow"] {
    border-color: ${themeConfig.sidebar.selectedText} !important;
  }
  /* Hover colapsado - flechas blancas */
  .pro-sidebar.collapsed .pro-menu-item:not(.pro-menu-item--active):not(.selected):hover > .pro-inner-item > span[class*="pro-arrow"] {
    border-color: ${themeConfig.neutral.white} !important;
  }

  .pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:focus {
    outline: none;
    color: black;
  }
  /* Sidebar item seleccionado - usando varios selectores por posibles nombres de clase */
  .pro-sidebar .pro-menu .pro-menu-item--active > .pro-inner-item,
  .pro-sidebar .pro-menu .pro-menu-item.pro-menu-item--active > .pro-inner-item,
  .pro-sidebar .pro-menu .pro-menu-item.selected > .pro-inner-item,
  .pro-sidebar .pro-menu .pro-menu-item.selected > a,
  .pro-sidebar .pro-menu-item.active > .pro-inner-item,
  .pro-sidebar .pro-menu-item.active > a,
  .pro-sidebar .pro-menu-item:hover.pro-menu-item--active > .pro-inner-item {
    background: ${({ theme }) => themeConfig.sidebar.selected} !important;
    color: ${({ theme }) => themeConfig.sidebar.selectedText} !important;
    border-radius: 5px;
  }
  .pro-sidebar .pro-menu .pro-menu-item--active > .pro-inner-item svg path,
  .pro-sidebar .pro-menu-item.active > .pro-inner-item svg path {
    fill: ${({ theme }) => themeConfig.sidebar.selectedText} !important;
  }
  .pro-sidebar .pro-menu .pro-menu-item--active > .pro-inner-item span,
  .pro-sidebar .pro-menu-item.active > .pro-inner-item span {
    color: ${({ theme }) => themeConfig.sidebar.selectedText} !important;
  }
  .pro-sidebar .pro-menu > ul > .pro-sub-menu > .pro-inner-list-item {
    padding: 0 24px;
  }
  .pro-sidebar.collapsed .pro-menu > ul > .pro-sub-menu > .pro-inner-list-item {
    .pro-menu-item {
      margin: 0 24px 0 10px;
    }
  }
  .pro-sidebar.collapsed
    .pro-menu
    > ul
    > .pro-menu-item.pro-sub-menu
    > .pro-inner-list-item
    > .popper-inner {
    max-height: 100vh;
    overflow-y: auto;
    background-color: white;
    box-shadow: -1px 1px 12px 0px ${({ theme }) => theme.shadows.strong};
    padding-left: 0;
    border-radius: 4px;
  }
  .suffix-wrapper {
    background: ${({ theme }) => themeConfig.primary.purpleFade};
    border-radius: 8px;
    width: 14px;
    color: ${({ theme }) => themeConfig.primary.purpleFadeDark};
    height: 15px;
    align-items: baseline;
    display: flex;
  }
  .prefix-wrapper {
    position: absolute;
    left: 156px;
    background: ${({ theme }) => theme.neutral.gray[200]};
    border-radius: 8px;
    width: 14px;
    color: ${({ theme }) => theme.text.primary};
    height: 15px;
    align-items: baseline;
    display: flex;
  }

  .submenu-hover:hover {
    .material-icons {
      color: ${({ theme }) => theme.text.primary};
    }
    background: ${({ theme }) => theme.neutral.gray[1600]}26;
  }
  .tab-mobile-menu {
    @media only screen and (max-width: 1024px) {
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      height: ${({ isCollapse }) => (isCollapse ? "100%" : "")};
      overflow: ${({ isCollapse }) => (isCollapse ? "hidden" : "visible")};
    }
    @media only screen and (min-width: 1025px) and (max-width: 3000px) {
      display: none;
    }
  }
  .desktop-menu {
    @media only screen and (max-width: 1024px) {
      display: none;
    }
    @media only screen and (min-width: 1025px) and (max-width: 3000px) {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }
  .menu-button {
    display: none;
  }
  @media only screen and (min-width: 1025px) {
    .menu-button {
      display: block;
    }
  }
  .arrow-up {
    width: 0;
    height: 0;
    border-left: 0.8rem solid transparent;
    border-right: 0.8rem solid transparent;
    border-bottom: 2rem solid ${({ theme }) => theme.neutral.gray[200]};
  }
  .info-icon {
    color: ${({ theme }) => theme.status.error};
    margin: 5px;
  }

  .ICE-label {
    color: ${({ theme }) => theme.neutral.black};
    font-weight: 600;
    margin-right: 15px;
    text-decoration: underline;
    @media only screen and (min-width: 821px) and (max-width: 3000px) {
      display: none;
    }
  }

  .mr-15 {
    margin-right: 15px;
  }

  .SOS-label {
    color: ${({ theme }) => theme.neutral.black};
    font-weight: 600;
    u {
      cursor: pointer;
    }
    .active {
      color: ${({ theme }) => themeConfig.primary.purpleOpacity};
    }
    @media only screen and (max-width: 820px) {
      display: none;
    }
  }
  .relative-container-ice {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const AppBarStyle = styled.div`
  z-index: 0;
  transition: width 2s, height 4s;
  transition-timing-function: ease;
  transition-duration: 2s;
  /* transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
      }); */
  background-color: ${({ theme }) => theme.neutral.white};
  border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
`;
export const DisplayName = styled.div`
  width: 47%;
  display: flex;
  margin: auto;
  align-items: center;
  justify-content: right;
  svg {
    color: ${({ theme }) => themeConfig.primary.purple};
    width: 1.83vw;
    margin: 5px;
    height: 1.83vw;
    @media only screen and (max-width: 768px) {
      width: 20px;
      height: 20px;
    }
  }

  .ice-label {
    display: inline-block;
    color: ${({ theme }) => theme.neutral.black};
    max-width: 80px;
    font-size: 0.8rem;
    font-weight: 700;
    text-decoration: underline;

    @media only screen and (max-width: 820px) {
      display: none !important;
    }
  }

  .ice-label-clickeable {
    display: inline-block;
    color: ${({ theme }) => theme.neutral.black};
    font-size: 1.1rem;
    font-weight: 700;
    text-decoration: underline;
    cursor: pointer;
    transition: color 0.2s ease;

    &:hover {
      color: ${({ theme }) => themeConfig.button.primary};
    }

    @media only screen and (max-width: 820px) {
      display: none !important;
    }
  }
  @media only screen and (max-width: 400px) {
    width: 6em;
  }
  @media only screen and (min-width: 401px) and (max-width: 600px) {
    width: 20em;
  }
  @media only screen and (min-width: 601px) and (max-width: 1100px) {
    width: 46em;
  }
  @media only screen and (min-width: 2000px) and (max-width: 3000px) {
    width: 85em;
  }
  .mood-meter-btn {
    position: relative;
    display: flex;
    align-items: center;
  }
`;
export const ImageLogout = styled.div`
  display: contents;
  cursor: pointer;
`;
export const ImageApps = styled.div`
  display: contents;
  cursor: pointer;
`;

export const ContentUserInfo = styled.div`
  display: contents;
  cursor: pointer;
  /* width: 90%;
  text-align: end;
  padding: 0px 0px;
  margin: 0px 0px;
   br {
    display: none;
  }
  p:nth-child(1) {
    color: purple;
    padding: 0;
    margin: 0;
    font-size: calc(1vw + 0.1em);
    text-align: end;
  }
  p:nth-child(3) {
    color: #008a98;
    font-size: calc(1vw + 0.01em);
    padding: 0;
    font-variant: all-small-caps;
    margin: 0;
    text-align: end;
    font-weight: bolder;
  } */

  .user-icon {
    @media only screen and (max-width: 768px) {
      width: 33.33333333% !important;
    }
  }

  .username-role {
    @media only screen and (max-width: 768px) {
      width: 45% !important;
    }
  }

  .user-name,
  .sign-out {
    @media only screen and (max-width: 768px) {
      font-size: 12px;
    }
  }
  .user-role {
    @media only screen and (max-width: 768px) {
      font-size: 10px;
    }
  }
`;

export const ImgLogoTPHomeMenu = styled.div`
  content: url(${(props) => props.srclogo});
  width: 13.324vw;
  height: auto;
  @media only screen and (max-width: 700px) {
    width: 100px;
    height: 35px;
  }
`;

export const ContentModalGlobal = styled.div`
  position: absolute;
  left: 35.2%;
  right: 35.2%;
  top: 3.64%;
  bottom: 75.77%;
  background: ${({ theme }) => theme.primaryBackgroundLight};
  border: 1px solid ${({ theme }) => theme.neutral.gray[600]};
  box-sizing: border-box;
  box-shadow: 2px 2px 25px ${({ theme }) => theme.shadows.strong};
  border-radius: 4px;
  height: fit-content;
`;
export const CloseModalGlobal = styled.div`
  height: 3em;
  width: 100%;
  text-align: end;
  padding: 1em;
  font-weight: 600;
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.black};
    text-decoration: none;
    background-color: transparent;
  }
`;

export const ContainterNotificationHome = styled.div`
  position: relative;
`;
export const TextModalGlobal = styled.div`
  padding: 1em;
  border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  text-align: center;
  height: 8em;
  svg {
    height: 1.5em;
    width: 2em;
  }
`;

export const ButtonGlobal = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 36px;
  left: 732px;
  top: 336px;
  background: ${({ theme }) => themeConfig.button.primary};
  border-radius: 4px;
  border: none;
  margin: 1em auto;
  color: ${({ theme }) => theme.neutral.white};
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
`;

export const ButtonNotification = styled.button`
  border: none;
  cursor: pointer;
  background-color: transparent;
  position: relative;
  opacity: ${({ isDisabled }) => isDisabled ? "0.4" : "1"};
  span {
    position: absolute;
    width: 5px;
    height: 5px;
    background: ${({ theme }) => themeConfig.primary.purplePink};
    border-radius: 100%;
    left: 41%;
    top: 25%;
  }
  svg {
    padding-top: 4px;
  }
`;

export const ButtonMoodMeter = styled.button`
  border: none;
  cursor: pointer;
  background-color: transparent;
  .notification-icon {
    width: 16px !important;
    height: 16px !important;
    position: absolute;
    border-radius: 99px;
    right: -1px;
    top: -4px;
    background: ${({ isDisabled, theme }) => (isDisabled ? theme.neutral.gray[1600] : themeConfig.primary.redDark)};
  }
  svg {
    width: 22px !important;
    height: 25px !important;
  }
  span {
    color: ${({ theme }) => theme.neutral.white};
    top: -4px;
    position: relative;
    font-size: 10px;
    right: 1px;
  }
`;

export const ContentTooltip = styled.div`
  display: grid;
  grid-template-columns: 10em 1fr;
  grid-gap: 5px;
  height: auto;
  padding: 0.5em;

  span {
    font-weight: 600;
    font-size: 11px;
    color: ${({ theme }) => theme.neutral.gray[2000]};
  }
`;

export const ButtonApp = styled.img`
  display: block;
  cursor: pointer;
  margin: auto;
  width: 43px;
  padding-bottom: 10px;
  @media only screen and (max-width: 500px) {
    width: 30px;
  }
`;

export const ImageContainer = styled.div`
  cursor: pointer;
  text-align: center;
  span {
    @media only screen and (max-width: 500px) {
      font-size: 8px;
    }
  }
`;
export const NameClient = styled.div`
  color: ${({ theme }) => theme.neutral.gray[3100]};
  width: 33%;
  display: inline-block;
  font-size: 23px;
  float: left;
  height: 100%;
  div {
    position: relative;
    background: ${(props) => (props.super ? props.theme.neutral.gray[400] : "")};
    display: inline-block;
    padding: ${(props) => (props.super ? "17px" : "0px")};
    cursor: pointer;
    height: 100%;
    width: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;
    @media only screen and (min-width: 600px) and (max-width: 1024px) {
      left: 20%;
    }
    @media only screen and (min-width: 400px) and (max-width: 600px) {
      left: 30%;
    }
    @media only screen and (max-width: 400px) {
      left: 40%;
    }
  }
  img {
    max-height: 1.5em;
    @media only screen and (max-width: 600px) {
      width: 50px;
      height: 16px;
    }
  }
  svg {
    margin-left: 4em;
    @media only screen and (min-width: 426px) and (max-width: 1024px) {
      margin-left: 1em;
    }
    @media only screen and (min-width: 385px) and (max-width: 425px) {
      margin-left: 2em;
    }
    @media only screen and (min-width: 350px) and (max-width: 384px) {
      margin-left: 1em;
    }
    @media only screen and (max-width: 349px) {
      margin-left: 0.3em;
    }
  }
`;

export const ContentChangeTenant = styled.div`
  background: ${({ theme }) => theme.neutral.white};
  width: 26em;
  display: grid;
  grid-auto-rows: 2em 8em 3em;
  padding: 1em;
  border-radius: 7px;
  margin: 9em auto;
`;
export const ButtonsChangeTenant = styled.div`
  width: 14em;
  display: inline-flex;
  margin: auto;
  grid-gap: 1em;
`;

export const ButtonCancel = styled.button`
  background: ${({ theme }) => theme.neutral.white};
  color: ${({ theme }) => themeConfig.button.primaryBorder};
  font-size: 14px;
  font-weight: 500;
  border: 1px solid ${({ theme }) => themeConfig.button.primaryBorder};
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 100%;
  height: 43.21px;
  &:hover {
    box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.shadows.medium};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;

export const ButtonCreate = styled.button`
  background: ${({ theme }) => themeConfig.button.primary};
  color: ${({ theme }) => theme.neutral.white};
  font-size: 14px;
  font-weight: 500;
  border: none;
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 100%;
  height: 43.21px;
  &:hover {
    box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.shadows.medium};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;

export const HR = styled.hr`
  background-color: ${({ theme }) => theme.neutral.gray[600]};
  height: 1px;
  width: 100%;
  margin-top: 1em;
  margin-bottom: 1.75em;
`;

export const RightSeparator = styled.div`
  border-right: 1px solid ${({ theme }) => themeConfig.primary.icon};
  margin: 10px;
  height: 1.5em;

  @media only screen and (max-width: 768px) {
    display: none;
  }
  @media only screen and (min-width: 769px) and (max-width: 1024px) {
    height: 1.2em;
  }
`;
export const ContentLogin = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
`;

export const MainContent = styled.div`
  width: 100%;
`;

export const LoginButton = styled.button`
  color: ${({ theme }) => theme.neutral.white};
  margin-right: 5%;
  border: none;
  height: 2.928vw;
  width: 7.321vw;
  font-size: 1.025vw;
  font-weight: 600;
  background: ${({ theme }) => themeConfig.primary.gradient};
  border-radius: 10px;
  @media only screen and (max-width: 768px) {
    width: 56px;
    height: 22px;
    font-size: 8px;
  }
`;

export const ContentRight = styled.div`
  padding: ${({ homePage }) => (homePage ? "0" : "10px")};
  @media only screen and (min-width: 769px) {
    padding: ${({ homePage }) => (homePage ? "0" : "10px 3px")};
  }
  @media only screen and (min-width: 491px) and (max-width: 768px) {
    padding: ${({ homePage }) => (homePage ? "0" : "10px 3px")};
  }
  @media only screen and (max-width: 480px) {
    padding: ${({ homePage }) => (homePage ? "0" : "10px 3px")};
  }
`;

export const ContentTwoFactor = styled.div`
  width: 60%;
  font-size: 12px;
  display: flex;
  justify-content: center;
  span {
    color: ${({ theme }) => themeConfig.primary.blue};
    text-decoration: underline;
    cursor: pointer;
  }
  p {
    max-width: 270px;
  }
`;
export const TextInformationCode = styled.p`
  margin: 0 auto;
`;

export const HeaderContentQr = styled.div`
  padding: 1em;
  border-bottom: 1px solid ${({ theme }) => theme.neutral.gray[1300]};
  div {
    float: left;
    font-size: 16px;
    color: ${({ theme }) => theme.neutral.gray[1800]};
    font-weight: 70;
  }
  svg {
    float: right;
    cursor: pointer;
  }
`;
export const ContentQr = styled.div`
  background: ${({ theme }) => theme.neutral.white};
  width: 22em;
  margin: 4vh auto;
  display: grid;
`;
export const InfoQrCode = styled.div`
  padding: 1em;
  height: 22em;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 0.3em;
  }
`;
export const QrImg = styled.img`
  display: block;
  margin: 0 auto;
  width: 16em;
  height: auto;
`;

export const ContentProfileIcon = styled.div`
  display: flex;
  justify-content: center;
  cursor: pointer;
  .arrow-drop-dowm {
    color: ${({ theme }) => theme.neutral.gray[3000]};
    width: 16px;
    height: 16px;
    margin-top: 27%;
    @media only screen and (min-width: 2000px) and (max-width: 3000px) {
      width: 20px;
      height: 20px;
    }
  }
`;

export const ContentPersonIcon = styled.div`
  width: 90%;
  height: 90%;
  border-radius: 99px;
  background-color: ${({ theme }) => theme.neutral.gray[200]};
  display: flex;
  justify-content: center;
  align-items: center;
  @media only screen and (min-width: 2000px) and (max-width: 3000px) {
    width: 3em;
    height: 3em;
  }
  .person-icon {
    color: ${({ theme }) => theme.neutral.gray[3000]};
  }
`;

export const SOSCountRequests = styled.div`
  position: absolute;
  right: 0px;
  top: 0px;
  background: ${({ theme }) => themeConfig.primary.redDark};
  min-width: 15px;
  height: 15px;
  color: ${({ theme }) => theme.neutral.white};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 99px;
  font-size: 10px;
  padding: 5px;
  cursor: pointer;

  @media only screen and (min-width: 2000px) and (max-width: 3000px) {
    top: 3px;
  }
`;

export const IconCollapseStyle = styled.div`
  background-color: ${({ theme }) => theme.background.light};
  margin: "0";
  margin-left: 15px;
  button {
    @media only screen and (min-width: 425px) and (max-width: 768px) {
      padding: 5px 5px;
    }
    @media only screen and (max-width: 425px) {
      padding: 10px 8px;
    }
  }
  .menu-icon {
    @media only screen and (max-width: 425px) {
      width: 0.8em;
      height: 0.8em;
    }
  }
`;

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    zIndex: 5,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: theme.palette.background.paper,
    /*     border: '1px solid ${({ theme }) => theme.neutral.gray[400]}', */
  },
  appBarShift: {
    // marginLeft: drawerWidth,
    // width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: "none",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    minHeight: "40px !important",
    height: "4.612vw",
    maxHeight: "65px",
  },
  content: {
    flexGrow: 1,
    overflowY: "auto",
    overflowX: "hidden",
    height: "100%",
  },
  homeLoggedinContent: {
    display: "grid",
    gridTemplateColumns: "minmax(58px, max-content) minmax(100px,auto)",
    "@media (max-width: 1024px)": {
      gridTemplateColumns: "minmax(100px,auto)",
    },
  },
}));

export const CenterContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;
export const TPIDContainer = styled.div`
  display: grid;
  grid-template-columns: 90% 10%;
  label {
    font-weight: 400;
    font-size: 12px;
    color: ${({ theme }) => theme.neutral.black};
    line-height: 19px;
    width: 100%;
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
    overflow-wrap: anywhere;
    word-break: break-word;
  }
  button {
    width: 20px;
    height: 20px;
    justify-self: end;

    svg {
      color: ${({ theme }) => themeConfig.primary.purple};
    }
  }
`;

export const Overlay = styled.div`
  opacity: 0.6;
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background-color: #5a5454;
  display: ${({ showOverlay }) => (showOverlay ? "block" : "none")};
`;

export const ContentRowData = styled.p`
  overflow: hidden;
  white-space: nowrap;
  width: 163px;
  text-overflow: ellipsis;
`;

export const ICEButton = styled.button`
  width: 3.5vw;
  height: 3.5vw;
  border-radius: 50%;
  max-width: 55px;
  max-height: 55px;
  background: radial-gradient(
    53.21% 53.21% at 50% 50%,
    ${({ theme }) => themeConfig.primary.purplePink} 54.17%,
    ${({ theme }) => themeConfig.primary.purple} 100%
  );
  /* opacity: ${({ buttonStatus }) => (buttonStatus !== "Open" ? "1" : "0.4")}; */
  box-shadow: 0px 0px 12px rgb(0 0 0 / 30%);
  outline: none;
  border: none;
  color: ${({ theme }) => theme.neutral.white};
  font-weight: 900;
  font-size: 12px;
  transition: 0.2s all;
  cursor: pointer !important;
  &:hover {
    transform: scale(0.98);
    box-shadow: 3px 2px 22px 1px rgb(0 0 0 / 24%);
  }
  .push-here {
    font-size: 6px;
    font-weight: 900;
    width: 100%;
    margin: 0;
    @media only screen and (max-width: 750px) {
      font-size: 10px;
    }
  }
  @media only screen and (max-width: 820px) {
    display: none;
  }
`;

export const SideMenuButton = styled.div`
  width: 208px;
  height: 240px;
  flex-shrink: 0;
  border-bottom: 4px solid ${({ theme }) => theme.background.primary};
  background: ${({ theme }) => themeConfig.primary.pinkBackground};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .heading {
    text-align: center;
    width: 100%;
    color: ${({ theme }) => theme.neutral.black};
    font-family: ${({ theme }) => theme.font.primary}, sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin-top: -19px;
  }
  .img-container {
    width: 120px;
    height: 120px;
    flex-shrink: 0;
    filter: drop-shadow(0px 0px 15px rgba(0, 0, 0, 0.3));
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
  }
  .img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .button {
    display: flex;
    width: 58.627px;
    height: 10.824px;
    flex-direction: column;
    justify-content: center;
    flex-shrink: 0;
    color: ${({ theme }) => theme.neutral.white};
    text-align: center;
    font-family: ${({ theme }) => theme.font.primary};
    font-size: 25px;
    font-style: normal;
    font-weight: 700;
    line-height: 12px;
    position: absolute;
  }
  .clickText {
    margin-top: 10px;
    color: ${({ theme }) => theme.text.primary};
    font-family: ${({ theme }) => theme.font.primary};
    font-size: 14px;
    font-weight: 700;
    line-height: normal;
    text-align: center;
  }

  .emergencyText {
    margin-top: 5px;
    color: ${({ theme }) => theme.text.primary};
    font-family: ${({ theme }) => theme.font.primary};
    font-size: 14px;
    font-weight: 500;
    line-height: normal;
    text-align: center;
  }
`;

export const Picture = styled.div`
  display: flex;
  width: 2em;
  height: 2em;
  border-radius: 99px;
  margin-top: 1rem;
  background: ${({ bgColor, photo }) => (photo) ? "url(" + photo + ")" : bgColor};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  justify-content: center;
  align-items: center;
  color: ${({ bgColor, photo }) => (bgColor || photo ? "white" : "black")};
  font-size: ${({ valuePictureWidth }) => valuePictureWidth + "px"};
  &:hover {
    opacity: 0.8;
    border: 4px solid ${({ theme }) => themeConfig.button.primary};
  }
`;

export const MiniPicture = styled.div`
  display: flex;
  width: 1.5em;
  height: 1.5em;
  border-radius: 99px;
  margin-top: 0.4rem;
  background: ${({ bgColor, photo }) => (photo) ? "url(" + photo + ")" : bgColor};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  justify-content: center;
  align-items: center;
  color: ${({ bgColor, photo }) => (bgColor || photo ? "white" : "black")};
  font-size: ${({ valuePictureWidth }) => valuePictureWidth + "px"};
  &:hover {
    opacity: 0.8;
    border: 4px solid ${({ theme }) => themeConfig.button.primary};
  }
`;
